import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'collateralTrackingNumberToWarehouseBank',
    label: 'Collateral Tracking Number to Warehouse Bank',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'collateralTrackingNumberWarehouseBankToInvestor',
    label: 'Collateral Tracking Number from Warehouse Bank to Investor',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'noteAirbillToWarehouseNumber',
    label: 'Note Airbill Number To Warehouse',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'noteAirbillToInvNumber',
    label: 'Note Airbill Number To INV',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'trackingNumberTitleCompanyToLender',
    label: 'Tracking # Title Company to Lender',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'shippedTitleCompanyToLenderDate',
    label: 'Shipped Title Company to Lender Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'receivedTitleCompanyToLenderDate',
    label: 'Received Title Company to Lender Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'collateralShippedToWarehouseDate',
    label: 'Collateral Shipped to Warehouse Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'collateralReceivedToWarehouseDate',
    label: 'Collateral Received to Warehouse Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'noteTrackingNumberToWarehouse',
    label: 'Note Tracking # to Warehouse',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'noteShippedToWarehouseDate',
    label: 'Note Shipped to Warehouse Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'noteReceivedToWarehouseDate',
    label: 'Note Received to Warehouse Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'collateralTrackingNumberToInvestor',
    label: 'Collateral Tracking # to Investor',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'collateralShippedToInvestorDate',
    label: 'Collateral Shipped to Investor Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'collateralReceivedToInvestorDate',
    label: 'Collateral Received to Investor Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'noteTrackingNumberToInvestor',
    label: 'Note Tracking # to Investor',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'noteShippedToInvestorDate',
    label: 'Note Shipped to Investor Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'noteReceivedToInvestorDate',
    label: 'Note Received to Investor Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'noteTrackingNumberFromOriginalInvestor',
    label: 'Note Tracking # from Original Investor',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'originalMortgageTrackingNumberToInvestor',
    label: 'Original Mortgage Tracking # to Investor',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const shippingInformationForm = {
  name: FormNames.POST_CLOSING,
  label: 'Shipping Information',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
